import { render } from "./ClientFormsView.vue?vue&type=template&id=813b055c&scoped=true"
import script from "./ClientFormsView.vue?vue&type=script&lang=js"
export * from "./ClientFormsView.vue?vue&type=script&lang=js"

import "./ClientFormsView.vue?vue&type=style&index=0&id=813b055c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-813b055c"]])

export default __exports__